<template>
  <div class="content">
    <div class="main">
      <ScriptShow ref="ScriptShow"></ScriptShow>
      <CronBindModal ref="CronBindModal" v-on:bindOk="refresh"></CronBindModal>
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="15">
            <Row class="title">
              <h4 :style="{float: 'left'}">计划任务详情</h4>
              <div :style="{float: 'right'}">
                <Button @click="$router.push({ name: 'cron_manage' })">返回</Button>
              </div>
            </Row>
            <div class="info-property">
              <dl>
                <dt>ID</dt><dd>{{info.id}}</dd>
              </dl>
              <dl>
                <dt>名称</dt><dd>{{info.name}}</dd>
              </dl>
              <dl>
                <dt>执行主机类型</dt>
                <dd v-if="info.os === 0"><Icon type="logo-tux" /> Linux</dd>
                <dd v-else-if="info.os === 1"><Icon type="logo-windows" /> windows</dd>
              </dl>
              <dl>
                <dt>执行</dt>
                <dd v-if="info.type === 'order'">执行指令</dd>
                <dd v-else-if="info.type === 'script'">执行脚本：{{ info.script.name }}</dd>
              </dl>
              <dl>
                <dt>执行内容</dt>
                <dd><codemirror ref="cronDetailCm" v-model="info.content" :options="cronDetailCmOptions"></codemirror></dd>
              </dl>
              <dl v-if="info.type === 'script'">
                <dt>脚本参数</dt><dd>{{info.params}}</dd>
              </dl>
              <dl>
                <dt>触发器</dt><dd>{{info.trigger}}</dd>
              </dl>
              <dl>
                <dt>创建用户</dt><dd>{{info.user_full_name}}</dd>
              </dl>
              <dl>
                <dt>创建时间</dt><dd>{{info.create_time_format}}</dd>
              </dl>
              <dl>
                <dt>正在运行的主机数</dt><dd>{{info.server.length}}</dd>
              </dl>
              <dl>
                <dt>描述</dt><dd>{{info.remark}}</dd>
              </dl>
            </div>
            <Row class="title" :style="{marginTop: '15px'}">
              <h4 :style="{float: 'left'}">正在运行该计划任务的的主机</h4>
              <a v-on:click="getBindServerData()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
              <div :style="{float: 'right'}">
                <Button type="primary" @click="bindModalOpen" icon="md-play">绑定主机</Button>
                <Button type="warning" @click="unbindConfirm" icon="md-square" :style="{marginLeft: '10px'}">选中解绑</Button>
                <Button type="error" @click="allUnbindConfirm" :style="{marginLeft: '10px'}">全部解绑</Button>
              </div>
            </Row>
            <Row>
              <Alert v-if="server.error" type="warning" show-icon>获取绑定数据失败</Alert>
              <Table
                v-else
                border
                size="small"
                :height="serverTableHeight"
                ref="table"
                :loading="server.loading"
                @on-row-click="rowClick"
                @on-selection-change="tableChange"
                :data="server.data"
                :columns="server.columns">
              </Table>
              <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: right;">
                  <page
                    :total="server.count"
                    :current="server.page"
                    :page-size="server.size"
                    @on-change="getBindServerData"></page>
                </div>
              </div>
            </Row>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="{ span: 8, offset: 1 }">
            <div class="title">
              <h4>日志信息</h4>
            </div>
            <GeminiScrollbar class="logs-scroll-bar">
              <Tabs type="card" :style="{paddingRight: '10px'}">
                <TabPane label="操作记录">
                  <OperationLogs :logs = "operationLogs" />
                  <Button
                    type="text"
                    :style="{color: '#57a3f3', marginLeft: '24px'}"
                    v-if="allOperationLogs.length > 3 & operationLogs.length === 3"
                    @click="operationLogs = allOperationLogs">
                    <span>显示全部 <Icon type="ios-arrow-down" /></span>
                  </Button>
                  <Button
                    type="text"
                    :style="{color: '#57a3f3', marginLeft: '24px'}"
                    v-if="operationLogs.length > 3"
                    @click="operationLogs = operationLogs.slice(0,3)">
                    <span>收起 <Icon type="ios-arrow-up" /></span>
                  </Button>
                </TabPane>
                <TabPane label="修改记录">
                  <Logs :logs = "RevisionLogs" />
                </TabPane>
              </Tabs>
            </GeminiScrollbar>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import { detailOpsCenterCron, getContentTypeId, getRevisionLogs, getCronBindServerList,
  getCronOperationLogsList, cronUnbindServerApi } from '@/api/opscenter'
import Logs from './Logs'
import OperationLogs from './cron-operation-logs'
import CronBindModal from './cron-bind-modal'
import ScriptShow from './script-show'
import { scriptTypeChange } from './scriptTools'
import codemirror from './scriptUse.js'

export default {
  name: 'cron-detail',
  components: {
    Logs,
    OperationLogs,
    codemirror,
    CronBindModal,
    ScriptShow
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  data () {
    return {
      info: {},
      RevisionLogs: [],
      operationLogs: [],
      allOperationLogs: [],
      contentTypeId: '',
      server: {
        data: [],
        columns: [
          {
            type: 'selection',
            width: 50,
            align: 'center'
          },
          {
            title: '主机名',
            key: 'hostname',
            tooltip: true,
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              let hostname = params.row.server.hostname
              if (!hostname) {
                hostname = '未识别'
              }
              return h('router-link', {
                props: {
                  to: {
                    name: 'server_detail',
                    params: { id: params.row.server.id }
                  }
                }
              }, hostname)
            }
          },
          {
            title: '私有IP',
            align: 'center',
            tooltip: true,
            key: 'inner_ip',
            minWidth: 90,
            render: (h, params) => {
              let result = params.row.server.inner_ip
              if (!result) {
                result = ''
              }
              return h('span', {
              }, result)
            }
          },
          {
            title: '公网IP',
            align: 'center',
            tooltip: true,
            key: 'public_ip',
            minWidth: 90,
            render: (h, params) => {
              let result = params.row.server.public_ip
              if (!result) {
                result = ''
              }
              return h('span', {
              }, result)
            }
          },
          {
            title: '服务器用户',
            align: 'center',
            tooltip: true,
            key: 'username',
            minWidth: 100
          },
          {
            title: '状态',
            key: 'status',
            tooltip: true,
            minWidth: 110,
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === '运行') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === '正在绑定' || params.row.status === '正在解绑') {
                iconType = 'ios-loading'
                style.color = '#ff9900'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 20
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status)
              ])
            }
          },
          {
            minWidth: 110,
            title: '操作',
            align: 'center',
            render: (h, params) => {
              if (params.row.status === '运行') {
                return h('div', [
                  h('Button', {
                    style: {
                      color: '#57a3f3'
                    },
                    props: {
                      type: 'text',
                      ghost: true
                    },
                    on: {
                      click: () => {
                        let data = {
                          content: params.row.content,
                          type: params.row.script_type
                        }
                        this.$refs.ScriptShow.openModal(data, true, true)
                      }
                    }
                  }, '详情'),
                  h('Poptip', {
                    props: {
                      confirm: true,
                      placement: 'bottom',
                      title: '确定要停止该主机的计划任务吗?'
                    },
                    on: {
                      'on-ok': () => {
                        this.unbindServerAction([params.row.server.id])
                      }
                    }
                  }, [
                    h('Button', {
                      style: {
                        color: '#57a3f3'
                      },
                      props: {
                        type: 'text',
                        ghost: true
                      }
                    }, '停止')
                  ])
                ])
              } else {
                let iconType = 'md-clock'
                let style = {
                  color: '#2d8cf0'
                }
                if (params.row.status === '正在绑定' || params.row.status === '正在解绑') {
                  iconType = 'ios-loading'
                  style.color = '#ff9900'
                  style.animation = 'ani-demo-spin 1s linear infinite'
                }
                return h('div', [
                  h('Icon', {
                    props: {
                      type: iconType,
                      size: 20
                    },
                    style: style
                  }),
                  h('span', {
                    style: {
                      color: style.color
                    }
                  }, ' ' + params.row.status)
                ])
              }
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        loading: false,
        error: false
      },
      listStyle: {
        width: '270px',
        height: '300px'
      },
      bindServerModel: false,
      already_bind_server_id: [],
      server_selected_list: [],
      serverTableHeight: 0,
      cronDetailCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      }
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    myCodeMirror () {
      return this.$refs.cronDetailCm.editor
    }
  },
  methods: {
    init () {
      this.getDetail()
      this.listener()
      this.getBindServerData()
      getContentTypeId({ 'model_name': 'Cron' }).then(res => {
        this.contentTypeId = res.data.content_type_id
        this.revisionLog()
        this.operationLog()
      })
      this.getServerGroup()
    },
    tableChange (data) {
      let that = this
      that.server_selected_list = []
      for (let i in data) {
        that.server_selected_list.push(data[i].server.id)
      }
    },
    rowClick (data, index) {
      let that = this
      that.$refs.table.objData[index]._isChecked = !that.$refs.table.objData[index]._isChecked
      if (that.$refs.table.objData[index]._isChecked) {
        that.server_selected_list.push(data.server.id)
      } else {
        that.server_selected_list = []
        for (let i in that.$refs.table.objData) {
          if (that.$refs.table.objData[i]._isChecked) {
            that.server_selected_list.push(that.$refs.table.objData[i].server.id)
          }
        }
      }
    },
    getDetail () {
      detailOpsCenterCron(this.$route.params.id).then(res => {
        this.info = res.data
        // this.server.data = res.data.server
        this.already_bind_server_id = []
        if (this.info.type === 'script') {
          if (this.info.script) {
            this.info.content = this.info.script.content
            this.typeChange(this.info.script.type)
          }
        } else {
          this.info.content = this.info.order
        }
        if (res.data.server.length > 5) {
          this.serverTableHeight = 250
        } else {
          this.serverTableHeight = 0
        }
        for (let i in this.server.data) {
          this.already_bind_server_id.push(this.server.data[i].id)
        }
      })
    },
    getBindServerData (value = 1) {
      this.server.page = value
      let reqParams = {
        size: this.server.size,
        page: this.server.page,
        cron: this.$route.params.id
      }
      this.server.loading = true
      this.server.error = false
      getCronBindServerList(reqParams).then(res => {
        this.server.loading = false
        this.server.data = res.data.results
        this.server.count = res.data.count
      }).catch(res => {
        this.server.loading = false
        this.server.data = []
        this.server.count = 0
        this.server.error = true
        this.$Notice.error({ title: '获取正在运行的服务器数据失败' })
      })
    },
    typeChange (value) {
      const lang = scriptTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    },
    revisionLog () {
      let params = {
        object_id: this.$route.params.id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    },
    operationLog () {
      let params = {
        cron: this.$route.params.id
      }
      getCronOperationLogsList(params).then(res => {
        this.operationLogs = res.data.slice(0, 3)
        this.allOperationLogs = res.data
      }).catch({})
    },
    refresh () {
      this.getBindServerData()
      this.getDetail()
      this.revisionLog()
      this.operationLog()
    },
    bindModalOpen () {
      this.$refs.CronBindModal.openModal(this.info)
    },
    unbindConfirm () {
      if (this.server_selected_list.length <= 0) {
        this.$Notice.error({
          title: '请选择主机！'
        })
        return
      }
      this.$Modal.confirm({
        title: '解绑',
        content: '<p>确定解绑选中主机的计划任务吗？</p>',
        onOk: () => {
          this.unbindServerAction(this.server_selected_list)
        }
      })
    },
    allUnbindConfirm () {
      let serverIds = []
      for (let i in this.info.server) {
        serverIds.push(this.info.server[i].id)
      }
      this.$Modal.confirm({
        title: '全部解绑',
        content: '<p>确定解绑全部主机的计划任务吗？</p>',
        onOk: () => {
          this.unbindServerAction(serverIds)
        }
      })
    },
    unbindServerAction (serverId) {
      let reqData = {
        id: this.$route.params.id,
        server_id: serverId
      }
      cronUnbindServerApi(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '请求成功，请等待执行结果！'
          })
          this.refresh()
        } else {
          this.$Notice.error({
            title: '操作失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'opscenter' && fData.module === 'cron') {
          if (fData.data) {
            if (fData.data.cron_id + '' === this.$route.params.id + '') {
              this.getBindServerData(this.server.page)
              this.operationLog()
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  @import './base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .logs-scroll-bar {
    height: 750px;
  }
</style>
